import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import store from './store/store'
import NetworkIssue from './views/NetworkIssue.vue'
import moment from 'moment'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/sign-in',
      name: 'sign-in',
      component: resolve => require([`@/views/SignIn`], resolve),
      beforeEnter(to, from, next) {
        const loggedIn = localStorage.getItem('user')
        if (loggedIn) {
          next('/')
        }
        next()
      }
    },
    {
      path: '/',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: resolve => require([`@/components/layout/layout`], resolve),
      children: [
        {
          path: '/',
          component: resolve => require([`@/views/Dashboard.vue`], resolve),
          meta: {
            requireAuth: true,
            permissions: ['Dashboard Module.View']
          }
        },
        {
          path: '/audit-record',
          component: resolve => require([`@/views/AuditRecord.vue`], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/404',
          name: '404',
          component: resolve => require([`@/views/NotFound.vue`], resolve)
        }
      ],
      beforeEnter(routeTo, routeFrom, next) {
        let tokenInfo = localStorage.getItem('tokenInfo')
          ? JSON.parse(localStorage.getItem('tokenInfo'))
          : null
        if (!tokenInfo) {
          window.localStorage.clear()
          router.push('/sign-in')
          return
        }
        if (routeFrom.path === '/sign-in' || routeFrom.path === '/register') {
          next()
          return
        } else {
          let expireDiff = moment
            .unix(tokenInfo.expires_on)
            .diff(moment(), 'minutes')
          if (expireDiff < 5 && !store.state.user.token_refreshing) {
            store
              .dispatch('user/refreshToken')
              .then(() => {
                next()
                return
              })
              .catch(() => {
                store.dispatch('user/logout')
              })
          } else {
            next()
            return
          }
        }
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/network-issue',
      name: 'network-issue',
      component: NetworkIssue
    }
  ]
})

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start()
  const loggedIn = localStorage.getItem('user')
  // If user don't login, site will directly jump to the sign in page
  if (routeTo.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/sign-in')
  }

  // Whether the current user has permission to view the page
  // if (
  //   routeTo.meta &&
  //   routeTo.meta.permissions &&
  //   routeTo.meta.permissions.length
  // ) {
  //   let flag = false
  //   let permissions = JSON.parse(localStorage.getItem('permissions'))
  //   permissions.forEach(permission => {
  //     if (routeTo.meta.permissions.indexOf(permission) > -1) {
  //       flag = true
  //     }
  //   })
  //   if (!flag) {
  //     next('/404')
  //   }
  // }

  next()
})

router.afterEach(() => {
  NProgress.done()
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
export default router
